import * as React from "react"
const CheckCircleSolidIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={22}
    aria-label="Check Circle Icon"
    {...props}
  >
    <path 
    fill="currentcolor"
    d="M11 .992A9.775 9.775 0 0 0 5.96 2.36a9.716 9.716 0 0 0-3.6 3.6A9.775 9.775 0 0 0 .992 11c0 1.808.456 3.488 1.368 5.04a9.716 9.716 0 0 0 3.6 3.6A9.775 9.775 0 0 0 11 21.008a9.775 9.775 0 0 0 5.04-1.368 9.716 9.716 0 0 0 3.6-3.6A9.775 9.775 0 0 0 21.008 11a9.775 9.775 0 0 0-1.368-5.04 9.716 9.716 0 0 0-3.6-3.6A9.775 9.775 0 0 0 11 .992ZM9.248 15.68l-1.416-1.392L5 11.456l1.416-1.416 2.832 2.832 6.36-6.384 1.416 1.416-7.776 7.776Z" />
  </svg>
)
export default CheckCircleSolidIcon
